import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useGetCardSetConfig } from '@sorare/core/src/set';

import bundesligaBackgroundWide from './assets/background-bundesliga-wide.webp';
import bundesligaBackground from './assets/background-bundesliga.webp';
import backgroundColors from './assets/background-colors.webp';
import laligaBackgroundWide from './assets/background-laliga-wide.webp';
import laligaBackground from './assets/background-laliga.webp';
import ligue1BackgroundWide from './assets/background-ligue1-wide.webp';
import ligue1Background from './assets/background-ligue1.webp';
import nbaBackgroundWide from './assets/background-nba-wide.webp';
import nbaBackground from './assets/background-nba.webp';
import plBackgroundWide from './assets/background-pl-wide.webp';
import plBackground from './assets/background-pl.webp';
import sorareBackgroundWide from './assets/background-sorare-wide.webp';
import sorareBackground from './assets/background-sorare.webp';
import backgroundStellarWide from './assets/background-stellar-wide.webp';
import backgroundStellar from './assets/background-stellar.webp';
import backgroundWinter from './assets/background-winter.webp';

const PACK_ASSETS: Record<
  Sport,
  | Record<string, Record<string, Record<'desktop' | 'mobile', string>>>
  | undefined
> = {
  [Sport.FOOTBALL]: {
    'common-base-set': {
      'premier-league-gb-eng': {
        desktop: plBackgroundWide,
        mobile: plBackground,
      },
      'laliga-es': { desktop: laligaBackgroundWide, mobile: laligaBackground },
      'bundesliga-de': {
        desktop: bundesligaBackgroundWide,
        mobile: bundesligaBackground,
      },
      'ligue-1-fr': { desktop: ligue1BackgroundWide, mobile: ligue1Background },
      default: { desktop: sorareBackgroundWide, mobile: sorareBackground },
    },
    winter: {
      default: {
        desktop: backgroundWinter,
        mobile: backgroundWinter,
      },
    },
    stellar: {
      default: { desktop: backgroundStellarWide, mobile: backgroundStellar },
    },
    colors: {
      default: { desktop: backgroundColors, mobile: backgroundColors },
    },
  },
  [Sport.NBA]: {
    'common-base-set': {
      default: {
        desktop: nbaBackgroundWide,
        mobile: nbaBackground,
      },
    },
    winter: {
      default: {
        desktop: backgroundWinter,
        mobile: backgroundWinter,
      },
    },
    stellar: {
      default: { desktop: backgroundStellarWide, mobile: backgroundStellar },
    },
  },
  [Sport.BASEBALL]: undefined,
};

export const usePackAssets = ({
  cardPackGroupSlug,
  cardSet,
}: {
  cardPackGroupSlug: Nullable<string>;
  cardSet?: string;
}): { desktop: string | undefined; mobile: string | undefined } => {
  const getCardSetconfig = useGetCardSetConfig();
  const { sport } = useSportContext();
  const currentBackground =
    PACK_ASSETS[sport]?.[getCardSetconfig(cardSet || 'common-base-set').slug];

  if (!currentBackground) {
    return { desktop: undefined, mobile: undefined };
  }
  return (
    (cardPackGroupSlug && currentBackground[cardPackGroupSlug]) ||
    currentBackground.default
  );
};
